import PlaceholderPage from '../components/PlaceholderPage';

export default function DashboardPage() {
  return <PlaceholderPage title="Dashboard" description="Overview of the streaming catalogue." />;
}
